import dayjs from "dayjs";
import { UiButton, UiDrawer, UiProfileModel, UiWarningRating } from "../../../../components";
import { formatPhoneNumber, formatAmount } from "../../../../utils/appUtils";
import { userIcon } from "../../../../assets/images";
import { LAWYERMANAGEMENT } from "../../../../apiServices/endpoints";
import "./style.scss";

const ConsultationDrawer = ({
	open,
	onClose,
	lawyer,
	consultations,
	loading = false,
	configGstPercentage = 0,
}) => {
	const calculateConsultationFees = (consultationInfo) => {
		const payment = consultationInfo?.consultationPaymentDetails || {};
		const baseAmount = Number(payment?.consultationAmountWithOutGst) || 0;
		const extendList = Array.isArray(consultationInfo?.extendConsultionDetailsList)
			? consultationInfo.extendConsultionDetailsList
			: consultationInfo?.extendConsultionDetailsList
				? [consultationInfo.extendConsultionDetailsList]
				: [];
		const extendAmount = extendList.reduce((sum, item) => sum + (Number(item?.amountWithoutGst) || 0), 0);
		const totalLawyerFees = typeof consultationInfo?.lawyerFeeAmount !== "undefined" && consultationInfo?.lawyerFeeAmount !== null
			? Number(consultationInfo.lawyerFeeAmount)
			: ((baseAmount + extendAmount) * Number(configGstPercentage) / 100);
		const totalExtendMin = extendList.reduce((sum, item) => sum + (Number(item?.extendMin) || 0), 0);
		return { totalLawyerFees, totalExtendMin };
	};
	const totalPaymentAcrossAll = (consultations || []).reduce((sum, consultationInfo) => {
		const { totalLawyerFees } = calculateConsultationFees(consultationInfo);
		return sum + totalLawyerFees;
	}, 0);
	const totalTdsAcrossAll = (consultations || []).reduce((sum, consultationInfo) => {
		return sum + (Number(consultationInfo?.tdsAmount) || 0);
	}, 0);

	const accountNumber = lawyer?.bankDetails?.decryptAccountNumber || "Nil";
	const ifscCode = lawyer?.bankDetails?.ifsc || "Nil";
	const bankName = lawyer?.bankDetails?.bankName || "Nil";

	return (
		<UiDrawer
			open={open}
			title={"Cons. View"}
			width={500}
			onClose={onClose}
			footer={
				<div className="flexible" style={{ justifyContent: "space-between", alignItems: "center" }}>
					<div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
						<div>Total Advocate Fee : ₹ {formatAmount(totalPaymentAcrossAll)}</div>
						<div>Total TDS : ₹ {formatAmount(totalTdsAcrossAll)}</div>
					</div>
					<UiButton onClick={onClose}>Close</UiButton>
				</div>
			}
		>
			<div className="transaction-consultation-view">
				<div className="lawyer-information">
					<div className="flexible" style={{ borderBottom: "1px solid #000" }}>
						<div className="flexible">
							{!lawyer?.profileUrl || String(lawyer?.profileUrl)?.includes("null") || String(lawyer?.profileUrl)?.includes("undefined") ? (
								<img
									src={userIcon}
									style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }}
									alt=""
								/>
							) : (
								<UiProfileModel imageUrl={`${LAWYERMANAGEMENT}/file${lawyer?.profileUrl}`} />
							)}
							<div>
								<h3 className="lawerInfo-detail">{lawyer?.lawyerName || "Nil"}</h3>
								{typeof lawyer?.warningCountAfterActive !== "undefined" && (
									<div style={{ padding: "5px 10px" }}>
										<UiWarningRating count={lawyer?.warningCountAfterActive} />
									</div>
								)}
							</div>
						</div>
						<div className="flexible">
							<div>
								<small className="information-header">Bar council Id</small>
								<h3 className="lawerInfo-detail">{lawyer?.barCouncilId || "Nil"}</h3>
							</div>
							<div>
								<small className="information-header">Advocate ID</small>
								<h3 className="lawerInfo-detail">{lawyer?.lawyerNo || "Nil"}</h3>
							</div>
						</div>
					</div>
					<div className="flexible" style={{ marginTop: "10px" }}>
						<div>
							<small className="information-header">Mobile Number</small>
							<h3 className="lawerInfo-detail">{lawyer?.mobileNumber ? formatPhoneNumber(lawyer?.mobileNumber) : "Nil"}</h3>
						</div>
						<div>
							<small className="information-header">E-mail Address</small>
							<h3 className="lawerInfo-detail">{lawyer?.email || "Nil"}</h3>
						</div>
					</div>
					<div className="flexible" style={{ marginTop: "10px", borderTop: "1px solid #0000001a", paddingTop: "10px" }}>
						<div>
							<small className="information-header">Bank Name</small>
							<h3 className="lawerInfo-detail">{bankName}</h3>
						</div>
						<div>
							<small className="information-header">Account Number</small>
							<h3 className="lawerInfo-detail">{accountNumber}</h3>
						</div>
						<div>
							<small className="information-header">IFSC Code</small>
							<h3 className="lawerInfo-detail">{ifscCode}</h3>
						</div>
					</div>
				</div>
				{loading ? (
					<div style={{ padding: "20px 0px", color: "#005D60" }}>Loading Cons...</div>
				) : (
					(consultations || []).map((consultationInfo, idx) => {
						const { totalLawyerFees, totalExtendMin } = calculateConsultationFees(consultationInfo);
						const consultationDate = consultationInfo?.consultationDate;
						const consultNo = consultationInfo?.consultationNo;
						const specialization = Array.isArray(consultationInfo?.specialization)
							? consultationInfo?.specialization.join(", ")
							: (consultationInfo?.specialization || "Nil");

						const payment = consultationInfo?.consultationPaymentDetails || {};
						const recordDetail = payment?.recordDetail || consultationInfo?.recordDetail || {};
						const recordWithoutGSt = Number(recordDetail?.recordAmountWithoutGst) || 0;
						const recordeGst = Number(recordDetail?.recordGstAmount) || 0;
						const recordTotalAmount = Number(recordDetail?.totalRecordAmount) || 0;

						const addOnGstAmountSum = payment?.addOnList?.reduce((sum, detail) => sum + (Number(detail?.gstAmount) || 0), 0) || 0;
						const addOnWithoutGstSum = payment?.addOnList?.reduce((sum, detail) => sum + (Number(detail?.amountWithOutGst) || 0), 0) || 0;
						const addOnTotalAmount = payment?.addOnList?.reduce((sum, detail) => sum + (Number(detail?.totalAmount) || 0), 0) || 0;

						const extendList = Array.isArray(consultationInfo?.extendConsultionDetailsList)
							? consultationInfo.extendConsultionDetailsList
							: consultationInfo?.extendConsultionDetailsList
								? [consultationInfo.extendConsultionDetailsList]
								: [];
						const extendWithoutGstSum = extendList.reduce((sum, detail) => sum + (Number(detail?.amountWithoutGst) || 0), 0) || 0;
						const extendGstAmountSum = extendList.reduce((sum, detail) => sum + (Number(detail?.gstAmount) || 0), 0) || 0;
						const extendTotalAmountSum = extendList.reduce((sum, detail) => sum + (Number(detail?.totalAmount) || 0), 0) || 0;

						const baseFeeDetails = payment?.consultationFeesDetails;
						const consultationWithoutGst = baseFeeDetails ? (Number(baseFeeDetails.consultationFeeWithoutGst) || 0) : (Number(payment?.consultationAmountWithOutGst) || 0);
						const consultationGstAmount = baseFeeDetails ? (Number(baseFeeDetails.consultationFeeGst) || 0) : (Number(payment?.consultationGstAmount) || 0);
						const consultationTotalAmount = baseFeeDetails ? (Number(baseFeeDetails.consultationTotalFee) || 0) : (Number(payment?.totalConsultationAmount) || 0);

						const totalWithoutGSt = Number(payment?.consultationAmountWithOutGst) || 0;
						const totalGstAmount = Number(payment?.consultationGstAmount) || 0;
						const totalAmounts = Number(payment?.totalConsultationAmount) || 0;

						const gstRate = consultationWithoutGst > 0 ? (consultationGstAmount / consultationWithoutGst) : (Number(configGstPercentage) / 100);

						const couponAmount = Number(payment?.couponAmount) || 0;
						const couponPercentage = Number(payment?.couponPercentage) || 0;
						const couponGst = couponAmount * gstRate;
						const couponTotal = couponAmount + couponGst;

						const discountAmount = Number(payment?.discountAmount) || 0;
						const discountPercentage = Number(payment?.discountPercentage) || 0;
						const discountGst = discountAmount * gstRate;
						const discountTotal = discountAmount + discountGst;

						return (
							<div className="lawyer-details" key={`${consultNo}-${idx}`} style={{ marginTop: idx === 0 ? 0 : 12 }}>
								<div className="flexible" style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
									<h3 className="lawyerInfo-heading">ID: {consultNo}</h3>
									<div> {consultationDate ? dayjs(consultationDate).format("DD-MM-YYYY") : "Nil"} </div>
								</div>
								<div className="flexible" style={{ flexWrap: "wrap" }}>
									<div>
										<small className="information-header">Call Min</small>
										<h3 className="lawerInfo-detail">{consultationInfo?.consultationTime || "Nil"} Min</h3>
									</div>
									<div>
										<small className="information-header">Expand Time</small>
										<h3 className="lawerInfo-detail">{totalExtendMin || "0"} Min</h3>
									</div>
									<div>
										<small className="information-header">Specialization</small>
										<h3 className="lawerInfo-detail">{specialization}</h3>
									</div>
									<div>
										<small className="information-header">Advocate Fee</small>
										<h3 className="lawerInfo-detail">₹ {formatAmount(totalLawyerFees)}</h3>
									</div>
									<div>
										<small className="information-header">TDS Amount</small>
										<h3 className="lawerInfo-detail">₹ {formatAmount(consultationInfo?.tdsAmount)}</h3>
									</div>
								</div>
								{payment && Object.keys(payment)?.length > 0 && (
									<div style={{ padding: "10px 0px" }}>
										<h3 className="lawyerInfo-heading" style={{ padding: "10px 0px" }}>Payment details</h3>
										<div>
											<table className="addon-table">
												<thead style={{ textAlign: "left" }}>
													<tr>
														<th>Members</th>
														<th>Fees without GST</th>
														<th>GST</th>
														<th>Total Fees</th>
													</tr>
												</thead>
												<tbody style={{ textAlign: "left" }}>
													<tr>
														<td>Consultation</td>
														<td>₹ {formatAmount(consultationWithoutGst)}</td>
														<td>₹ {formatAmount(consultationGstAmount)}</td>
														<td>₹ {formatAmount(consultationTotalAmount)}</td>
													</tr>
													<tr>
														<td>Add-on</td>
														<td>₹ {formatAmount(addOnWithoutGstSum)}</td>
														<td>₹ {formatAmount(addOnGstAmountSum)}</td>
														<td>₹ {formatAmount(addOnTotalAmount)}</td>
													</tr>
													{extendTotalAmountSum > 0 && (
														<tr>
															<td>Extend Consultation</td>
															<td>₹ {formatAmount(extendWithoutGstSum)}</td>
															<td>₹ {formatAmount(extendGstAmountSum)}</td>
															<td>₹ {formatAmount(extendTotalAmountSum)}</td>
														</tr>
													)}
													{recordTotalAmount > 0 && (
														<tr>
															<td>Record</td>
															<td>₹ {formatAmount(recordWithoutGSt)}</td>
															<td>₹ {formatAmount(recordeGst)}</td>
															<td>₹ {formatAmount(recordTotalAmount)}</td>
														</tr>
													)}
													{couponAmount > 0 && (
														<tr>
															<td>Coupon{couponPercentage > 0 ? ` (${couponPercentage}%)` : ""}</td>
															<td>- ₹ {formatAmount(couponAmount)}</td>
															<td>- ₹ {formatAmount(couponGst)}</td>
															<td>- ₹ {formatAmount(couponTotal)}</td>
														</tr>
													)}
													{discountAmount > 0 && (
														<tr>
															<td>Discount{discountPercentage > 0 ? ` (${discountPercentage}%)` : ""}</td>
															<td>- ₹ {formatAmount(discountAmount)}</td>
															<td>- ₹ {formatAmount(discountGst)}</td>
															<td>- ₹ {formatAmount(discountTotal)}</td>
														</tr>
													)}
													<tr style={{ fontWeight: 700 }}>
														<td>Total</td>
														<td>₹ {formatAmount(totalWithoutGSt)}</td>
														<td>₹ {formatAmount(totalGstAmount)}</td>
														<td>₹ {formatAmount(totalAmounts)}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								)}
							</div>
						);
					})
				)}
				{!loading && (!consultations || consultations?.length === 0) && (
					<div style={{ padding: "10px 0px", color: "#005D60" }}>No Cons. found.</div>
				)}
			</div>
		</UiDrawer>
	);
};

export default ConsultationDrawer;

